export const navigation = [
  { label: "Home", route: "/", desktop: true, responsive: true },
  {
    label: "About us",
    route: "/about",
    desktop: true,
    responsive: true
  },
  {
    label: "How it works",
    route: "/services",
    desktop: true,
    responsive: true
  },
  {
    label: "FAQ",
    route: "/faq",
    desktop: true,
    responsive: true
  },
  {
    label: "Pricing",
    route: "/pricing",
    desktop: true,
    responsive: true
  }
];
